<script>
import {driver} from "driver.js";
import 'driver.js/dist/driver.css'

export default {
  name: "driverChannelForm",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    driver: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      form: {
        adminId: "",
        organizationId: "",
        channelName: "",

      },
      rules: {
        organizationId: [
          {required: true, message: '请选择机构名称', trigger: 'blur'}
        ],
        channelName: [
          {required: true, message: '请输入渠道名称', trigger: 'blur'}
        ],
        adminId: [
          {required: true, message: '请选择负责人', trigger: 'blur'}
        ],
      },
      userList: [],
      driverObj: null,
      disabled:false
    }
  },
  async created() {
    await this.mixinOrganizations()
    if (this.rowData.id) {
      console.log(this.rowData);
      this.form = {...this.form, ...this.rowData}

    }

    if (this.mixinUserInfo.type === 3 && this.mixinUserInfo.platformType === 3) {
      if(!this.rowData.id){
        this.form.organizationId = this.mixinUserInfo.organizationId
        this.form.adminId = this.mixinUserInfo.id
      }

      this.disabled = true
    }
    await this.getUserListFn('created')
  },
  mounted() {
    this.getGuideFn()
  },
  methods: {
    getGuideFn() {
      this.driverObj = driver({
        showProgress: true,
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        doneBtnText: '完成',
        allowClose: false,
        steps: [
          {element: '.add-btn', popover: {title: '开始添加渠道', description: '点击“添加渠道”按钮，即可开始添加渠道商'}},
          {
            element: '.driverChannelForm1',
            popover: {
              title: '选择归属机构',
              description: '渠道需归属于平台的机构，点击“机构名称”即可选择。默认为当前用户归属机构',
              onPrevClick: () => {
                console.log('Next Button Clicked')
                this.driverObj.movePrevious()
                this.driverObj.destroy()
                this.$emit('handClose')
                this.$emit('driverPrev',)
              },
            }
          },
          {
            element: '.driverChannelForm2',
            popover: {title: '渠道名称命名', description: '您可输入15字以内的渠道名称，同一机构下渠道名称不可重复'}
          },
          {
            element: '.driverChannelForm3', popover: {
              title: '添加负责人',
              description: '为渠道负责人创建平台管理员账号后再添加该用户为负责人。负责人仅拥有查看和管理当前渠道的权限',
              onPopoverRender: (popover, {config, state}) => {
                const firstButton = document.createElement('button')
                firstButton.classList.add('pass-btn')
                firstButton.innerText = '创建负责人'
                popover.footerButtons.appendChild(firstButton)
                firstButton.addEventListener('click', () => {
                  console.log(666)
                  this.$router.push({path: '/member'})
                  this.driverObj.destroy()
                })
              }
            }
          },
        ],
        onNextClick: () => {
          this.driverObj.moveNext()
        },
      })
      this.driver && this.driverObj.drive(1)
    },
    async getUserListFn(type) {
      if (type !== 'created') {
        this.form.adminId = ''
      }
      let url = '/api/v1/manage/admin'
      let data = await this.$axios.get(url, {page: 1, size: 999, ...this.form, type: 3})
      if (data && data.code === 1) {
        this.userList = data.data
      }
    },
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let url = '/api/v1/manage/organizationChannel'
          let data = await this.$axios.post(url, this.form)
          if (data && data.code === 1) {
            this.$message.success('保存成功')
            this.$emit('handClose')
          }
        } else {
          this.$message.warning('请检查表单数据是否输入正确！')
          return false
        }
      })
    }
  }
}
</script>

<template>
  <div class="driverChannelForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item class="driverChannelForm1" label="机构名称" prop="organizationId">
        <el-select :disabled="!!form.id || disabled" v-model="form.organizationId" filterable @change="getUserListFn">
          <el-option v-for="( item, i ) in   organizations" :key="i"
                     :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="driverChannelForm2" label="渠道名称" prop="channelName">
        <el-input :disabled="!!form.id" v-model="form.channelName" placeholder="请输入渠道名称"></el-input>
      </el-form-item>
      <el-form-item class="driverChannelForm3" label="负责人" prop="adminId">
        <el-select :disabled="!form.organizationId || disabled" v-model="form.adminId" filterable clearable
        >
          <el-option v-for="(item, i) in userList" :key="i"
                     :value="item.id" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="flex-end">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="saveClick">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<style scoped lang="less">

</style>